import React, { useEffect, useState } from 'react';
import { Icons } from '@/theme/index';
import { SetupButton } from './SsoPromoContents/SetupButton';
import { SsoSideBarSvg } from './SsoPromoContents/SsoPromosSvg';
import {
  StyledCloseButton,
  CardContainer,
  CardIconContainer,
  CardButtonContainer,
  CardText,
  PrimaryText,
  SecondaryText,
} from './components';
import { useSsoPromoLogic } from './ssoUtils';

type SsoPromoSideBarProps = {
  ssoPromoLogic?: ReturnType<typeof useSsoPromoLogic>;
  imagePath?: string;
};

export const SsoPromoSideBar = ({
  ssoPromoLogic = useSsoPromoLogic(),
  imagePath,
}: SsoPromoSideBarProps) => {
  const { brandName, showApple, isOnSsoTest } = ssoPromoLogic;

  const secText = showApple
    ? 'Use Google or Apple to Log In'
    : 'Use Google to Log In';

  const [isVisible, setIsVisible] = useState(() => {
    const saved = localStorage.getItem('ssoSideBarVisible');
    return saved !== null ? JSON.parse(saved) : true;
  });

  useEffect(() => {
    localStorage.setItem('ssoSideBarVisible', JSON.stringify(isVisible));
  }, [isVisible]);

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible || !isOnSsoTest) return null;

  return (
    <CardContainer data-testid="sso-promo-sidebar">
      <CardButtonContainer>
        <StyledCloseButton onClick={handleClose} data-testid="close-button">
          <Icons.Close fontSize="small" />
        </StyledCloseButton>
      </CardButtonContainer>
      <CardIconContainer>
        {imagePath ? (
          <img
            src={imagePath}
            alt={`${brandName} logo`}
            style={{ height: 'auto', width: '100%' }}
          />
        ) : (
          <SsoSideBarSvg
            brandName={brandName}
            showApple={showApple}
            style={{ height: 'auto', width: '100%' }}
          />
        )}
      </CardIconContainer>
      <CardText>
        <PrimaryText>New! Quick & Secure:</PrimaryText>{' '}
        <SecondaryText id="sec-text" data-testid="secondary-text">
          {secText}
        </SecondaryText>
      </CardText>
      <SetupButton handleClose={() => {}} data-testid="setup-button" />
    </CardContainer>
  );
};
